import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/sections/Footer';
import { SEO } from '@/components/SEO';

const Privacy = () => {
  return (
    <main className="min-h-screen bg-background">
      <SEO
        title="Privacy Policy - Brace e Sapori Store | Informativa sulla Privacy"
        description="Informativa sulla privacy di Brace e Sapori Store. Scopri come trattiamo i tuoi dati personali, i tuoi diritti secondo il GDPR e come contattarci. Av Food Srl - San Giorgio Ionico."
        keywords="privacy policy brace e sapori store, informativa privacy e-commerce, GDPR, protezione dati personali, privacy store online"
        canonical="https://store.braceesapori.it/privacy"
      />
      <Header />
      <section className="py-16 px-6 md:py-24">
        <div className="mx-auto max-w-4xl">
          <div className="mb-8">
            <h1 className="mb-4 text-4xl font-semibold text-foreground md:text-5xl">
              Privacy Policy
            </h1>
            <p className="text-sm text-muted-foreground">
              Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>

          <div className="prose prose-slate max-w-none dark:prose-invert">
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">1. Titolare del Trattamento</h2>
            <p className="text-muted-foreground mb-4">
              Il titolare del trattamento dei dati personali è:
            </p>
            <div className="bg-card border border-border rounded-lg p-6 mb-6">
              <p className="font-semibold text-foreground mb-2">Av Food Srl</p>
              <p className="text-muted-foreground mb-2">
                Via P. B. Moscatelli, 8<br />
                74027 San Giorgio Ionico (TA)
              </p>
              <p className="text-muted-foreground">
                Informazioni aziendali disponibili su:{' '}
                <a 
                  href="https://www.ufficiocamerale.it/9508/av-food-srl" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-primary hover:underline"
                >
                  https://www.ufficiocamerale.it/9508/av-food-srl
                </a>
              </p>
            </div>

            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">2. Tipi di Dati Raccolti</h2>
            <p className="text-muted-foreground mb-4">
              Il presente sito web raccoglie i seguenti tipi di dati personali:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-6 space-y-2">
              <li>
                <strong className="text-foreground">Dati di navigazione:</strong> indirizzo IP, tipo di browser, 
                sistema operativo, pagine visitate, data e ora di accesso. Questi dati vengono raccolti 
                automaticamente attraverso i log del server e non consentono l'identificazione diretta dell'utente.
              </li>
              <li>
                <strong className="text-foreground">Dati forniti volontariamente:</strong> nome, cognome, 
                indirizzo email, numero di telefono, indirizzo di spedizione e fatturazione, eventuali altre 
                informazioni fornite durante la registrazione, il checkout o tramite moduli di contatto.
              </li>
              <li>
                <strong className="text-foreground">Dati di navigazione e comportamento:</strong> pagine visitate, 
                prodotti visualizzati, prodotti aggiunti al carrello, eventi e-commerce (acquisti completati), 
                ricerche effettuate. Questi dati vengono raccolti tramite Google Analytics e Meta Pixel previo consenso.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">3. Finalità del Trattamento</h2>
            <p className="text-muted-foreground mb-4">
              I dati personali vengono trattati per le seguenti finalità:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-6 space-y-2">
              <li>Gestione degli ordini e-commerce e della registrazione utenti</li>
              <li>Erogazione del servizio richiesto (vendita prodotti, spedizione, fatturazione)</li>
              <li>Analisi statistica del traffico e miglioramento dell'esperienza utente (tramite Google Analytics)</li>
              <li>Ottimizzazione delle campagne pubblicitarie e remarketing (tramite Meta Pixel)</li>
              <li>Risposta alle richieste degli utenti</li>
              <li>Adempimento di obblighi di legge, regolamenti o norme comunitarie</li>
              <li>Prevenzione di abusi o utilizzi fraudolenti del sito</li>
            </ul>

            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">4. Trattamento Dati Ordini e Utenti</h2>
            <p className="text-muted-foreground mb-4">
              I dati relativi agli ordini e-commerce e alla registrazione utenti vengono gestiti e trattati attraverso:
            </p>
            <div className="bg-card border border-border rounded-lg p-6 mb-4">
              <p className="font-semibold text-foreground mb-2">WooCommerce</p>
              <p className="text-muted-foreground mb-4">
                Gli ordini effettuati tramite il presente sito web vengono gestiti attraverso la piattaforma WooCommerce, 
                che opera come responsabile del trattamento ai sensi dell'art. 28 del GDPR. I dati degli ordini vengono 
                memorizzati sul server WordPress/WooCommerce e utilizzati per la gestione degli ordini, la fatturazione 
                e la spedizione.
              </p>
              <p className="text-muted-foreground">
                Per informazioni dettagliate sul trattamento dei dati: <a href="https://woocommerce.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Privacy Policy di WooCommerce</a>
              </p>
            </div>
            <div className="bg-card border border-border rounded-lg p-6 mb-6">
              <p className="font-semibold text-foreground mb-2">WooPayments</p>
              <p className="text-muted-foreground">
                I pagamenti vengono elaborati tramite WooPayments, che gestisce i dati di pagamento in conformità 
                con gli standard PCI-DSS. I dati della carta di credito non vengono memorizzati sul nostro server 
                ma vengono gestiti direttamente da WooPayments.
              </p>
            </div>

            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">5. Base Giuridica del Trattamento</h2>
            <p className="text-muted-foreground mb-6">
              Il trattamento dei dati personali si basa su:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-6 space-y-2">
              <li>Consenso dell'interessato (art. 6, comma 1, lett. a) GDPR)</li>
              <li>Esecuzione di un contratto o di misure precontrattuali (art. 6, comma 1, lett. b) GDPR)</li>
              <li>Adempimento di un obbligo legale (art. 6, comma 1, lett. c) GDPR)</li>
            </ul>

            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">6. Tecnologie Utilizzate</h2>
            <p className="text-muted-foreground mb-4">
              Il presente sito web è sviluppato utilizzando le seguenti tecnologie:
            </p>
            <div className="bg-card border border-border rounded-lg p-6 mb-6">
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li><strong className="text-foreground">React 18.3.1:</strong> libreria JavaScript per la costruzione di interfacce utente</li>
                <li><strong className="text-foreground">TypeScript:</strong> linguaggio di programmazione tipizzato</li>
                <li><strong className="text-foreground">Vite:</strong> strumento di build e sviluppo</li>
                <li><strong className="text-foreground">Tailwind CSS:</strong> framework CSS utility-first</li>
                <li><strong className="text-foreground">React Router DOM:</strong> libreria per il routing client-side</li>
                <li><strong className="text-foreground">Radix UI:</strong> componenti UI accessibili e senza stile</li>
                <li><strong className="text-foreground">TanStack Query:</strong> libreria per la gestione dello stato server-side</li>
              </ul>
            </div>

            <h3 className="text-xl font-semibold text-foreground mt-6 mb-3">6.1 Servizi di Analytics e Marketing</h3>
            <p className="text-muted-foreground mb-4">
              Il presente sito web utilizza i seguenti servizi di terze parti per l'analisi del traffico e il marketing digitale:
            </p>
            
            <div className="bg-card border border-border rounded-lg p-6 mb-4">
              <h4 className="font-semibold text-foreground mb-2">Google Tag Manager e Google Analytics</h4>
              <p className="text-muted-foreground mb-2">
                Utilizziamo Google Tag Manager (gtag.js) e Google Analytics per analizzare il comportamento degli utenti sul sito, 
                comprendere come gli utenti interagiscono con il sito e migliorare l'esperienza utente.
              </p>
              <p className="text-muted-foreground mb-2">
                <strong className="text-foreground">Dati raccolti:</strong> indirizzo IP (anonimizzato), tipo di browser, sistema operativo, 
                pagine visitate, durata della visita, provenienza del traffico, eventi e-commerce (visualizzazioni prodotto, aggiunte al carrello, acquisti).
              </p>
              <p className="text-muted-foreground mb-2">
                <strong className="text-foreground">Finalità:</strong> analisi statistica del traffico, miglioramento del sito, ottimizzazione delle campagne marketing.
              </p>
              <p className="text-muted-foreground">
                <strong className="text-foreground">Base giuridica:</strong> consenso dell'utente (art. 6, comma 1, lett. a) GDPR).
              </p>
              <p className="text-muted-foreground mt-2">
                Per maggiori informazioni: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Privacy Policy di Google</a>
              </p>
            </div>

            <div className="bg-card border border-border rounded-lg p-6 mb-6">
              <h4 className="font-semibold text-foreground mb-2">Meta Pixel (Facebook Pixel)</h4>
              <p className="text-muted-foreground mb-2">
                Utilizziamo Meta Pixel (Facebook Pixel) per tracciare le conversioni, ottimizzare le campagne pubblicitarie su Facebook e Instagram, 
                e creare audience personalizzate per il remarketing.
              </p>
              <p className="text-muted-foreground mb-2">
                <strong className="text-foreground">Dati raccolti:</strong> indirizzo IP, informazioni sul dispositivo, pagine visitate, 
                eventi e-commerce (visualizzazioni prodotto, aggiunte al carrello, acquisti completati), identificatori univoci.
              </p>
              <p className="text-muted-foreground mb-2">
                <strong className="text-foreground">Finalità:</strong> misurazione delle performance delle campagne pubblicitarie, 
                ottimizzazione degli annunci, remarketing, creazione di audience personalizzate.
              </p>
              <p className="text-muted-foreground">
                <strong className="text-foreground">Base giuridica:</strong> consenso dell'utente (art. 6, comma 1, lett. a) GDPR).
              </p>
              <p className="text-muted-foreground mt-2">
                Per maggiori informazioni: <a href="https://www.facebook.com/privacy/explanation" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Privacy Policy di Meta</a>
              </p>
            </div>

            <p className="text-muted-foreground mb-6">
              <strong className="text-foreground">Gestione del consenso:</strong> Puoi revocare il consenso al tracciamento in qualsiasi momento 
              modificando le impostazioni del tuo browser o utilizzando strumenti di opt-out forniti da Google e Meta. 
              Tuttavia, la disabilitazione di questi servizi potrebbe limitare alcune funzionalità del sito.
            </p>

            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">7. Cookie</h2>
            <p className="text-muted-foreground mb-6">
              Il presente sito web utilizza esclusivamente cookie tecnici strettamente necessari per il 
              funzionamento del sito. Per informazioni dettagliate, si prega di consultare la{' '}
              <a href="/cookie-policy" className="text-primary hover:underline">Cookie Policy</a>.
            </p>

            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">8. Conservazione dei Dati</h2>
            <p className="text-muted-foreground mb-4">
              I dati personali vengono conservati per il tempo strettamente necessario alle finalità per 
              le quali sono stati raccolti, nel rispetto dei termini di legge applicabili:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-6 space-y-2">
              <li><strong className="text-foreground">Dati degli ordini:</strong> conservati per 10 anni ai sensi degli obblighi fiscali e contabili</li>
              <li><strong className="text-foreground">Dati di registrazione utenti:</strong> conservati fino alla cancellazione dell'account o richiesta di cancellazione</li>
              <li><strong className="text-foreground">Dati di navigazione (Google Analytics):</strong> conservati per 26 mesi</li>
              <li><strong className="text-foreground">Dati Meta Pixel:</strong> conservati secondo le politiche di Meta (fino a 90 giorni per i cookie)</li>
              <li><strong className="text-foreground">Dati di contatto:</strong> conservati fino alla risoluzione della richiesta</li>
            </ul>
            <p className="text-muted-foreground mb-6">
              Al termine del periodo di conservazione, i dati vengono cancellati o anonimizzati in modo sicuro.
            </p>

            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">9. Diritti dell'Interessato</h2>
            <p className="text-muted-foreground mb-4">
              Ai sensi degli artt. 15-22 del GDPR, l'interessato ha il diritto di:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-6 space-y-2">
              <li>Ottenere la conferma dell'esistenza dei propri dati personali</li>
              <li>Accedere ai propri dati personali</li>
              <li>Ottenere la rettifica dei dati inesatti</li>
              <li>Ottenere la cancellazione dei dati (diritto all'oblio)</li>
              <li>Ottenere la limitazione del trattamento</li>
              <li>Opporsi al trattamento</li>
              <li>Richiedere la portabilità dei dati</li>
              <li>Revocare il consenso in qualsiasi momento</li>
              <li>Proporre reclamo all'Autorità Garante per la protezione dei dati personali</li>
            </ul>

            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">10. Comunicazione e Diffusione</h2>
            <p className="text-muted-foreground mb-4">
              I dati personali possono essere comunicati alle seguenti categorie di destinatari:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-6 space-y-2">
              <li>
                <strong className="text-foreground">Google LLC:</strong> per l'erogazione del servizio Google Analytics e Google Tag Manager. 
                I dati vengono trasferiti negli Stati Uniti in base alle clausole contrattuali standard approvate dalla Commissione Europea.
              </li>
              <li>
                <strong className="text-foreground">Meta Platforms Ireland Limited:</strong> per l'erogazione del servizio Meta Pixel. 
                I dati possono essere trasferiti negli Stati Uniti in base alle clausole contrattuali standard approvate dalla Commissione Europea.
              </li>
              <li>
                <strong className="text-foreground">Fornitori di servizi:</strong> società che forniscono servizi tecnici per il funzionamento del sito 
                (hosting, manutenzione, gestione ordini).
              </li>
              <li>
                <strong className="text-foreground">Autorità competenti:</strong> quando richiesto dalla legge o da un'autorità giudiziaria.
              </li>
            </ul>
            <p className="text-muted-foreground mb-6">
              I dati personali non vengono diffusi a terzi né comunicati per finalità diverse da quelle sopra indicate, 
              salvo nei casi previsti dalla legge o per l'esecuzione del servizio richiesto.
            </p>

            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">11. Sicurezza dei Dati</h2>
            <p className="text-muted-foreground mb-6">
              Il titolare adotta misure tecniche e organizzative appropriate per garantire la sicurezza dei 
              dati personali, prevenendo la perdita, l'uso illecito, l'accesso non autorizzato e la 
              divulgazione dei dati.
            </p>

            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">12. Contatti</h2>
            <p className="text-muted-foreground mb-4">
              Per esercitare i propri diritti o per qualsiasi richiesta relativa al trattamento dei dati 
              personali, è possibile contattare il titolare:
            </p>
            <div className="bg-card border border-border rounded-lg p-6 mb-6">
              <p className="text-muted-foreground mb-2">
                <strong className="text-foreground">Email:</strong>{' '}
                <a href="mailto:braceesapori@yahoo.com" className="text-primary hover:underline">
                  braceesapori@yahoo.com
                </a>
              </p>
              <p className="text-muted-foreground mb-2">
                <strong className="text-foreground">Telefono:</strong>{' '}
                <a href="tel:+393472916493" className="text-primary hover:underline">
                  347 291 6493
                </a>
              </p>
              <p className="text-muted-foreground">
                <strong className="text-foreground">Indirizzo:</strong> Via P. B. Moscatelli, 8, 74027 San Giorgio Ionico (TA)
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default Privacy;

